module.exports = __webpack_public_path__ + "img/vertical_7_1_8004.cc4b19cd.png";